import { ProductBalance } from '../../../common/constants'
import styles from './LubematchProductCard.module.css'
import {Tooltip} from "primereact/tooltip";
import noPhoto from  '../../../common/image/no photo stub.jpg'
import {Card, Form} from "react-bootstrap";
import "./../../../common/Layout/modal.css"
import {Button} from "primereact/button";
import "primeicons/primeicons.css";
import {Dialog} from "primereact/dialog";
import {ProductCardNew} from '../../Product/ProductCard/ProductCardNew'

export const LubematchProductCard = ({
                                id,
                                name,
                                number,
                                count,
                                decrementCount,
                                incrementCount,
                                countHandleClick,
                                countHandler,
                                articleList,
                                recommendPrice,
                                priceList,
                                balance,
                                deliveryDate,
                                smallImageUrls,
                                isDiscount,
                                countInCart,
                                productBalanceStatus,
                                presentTooltipRef,
                                presentDiv,
                                discountTooltip,
                                discountPersent,
                                isDiscountLabelHovered,
                                handleMouseEnterDiscountLabel,
                                handleMouseLeaveDiscountLabel,
                                setIsHovered,
                                divRef,
                                handleShow,
                                itemPriceIndex,
                                productButton,
                                show,
                                setShow,
                                add,
                                totalAmount
}) => {

    return(
        <div  className={`${styles.cardWrapper} ${productBalanceStatus === ProductBalance.OutOfStock  && styles.opacity05}` }>
            <Tooltip target={presentTooltipRef} content={discountTooltip} position='top' />
            <span className={styles.number_present} >{number} {presentDiv}</span>
            {articleList?.length && <span className={styles.article} >{articleList[0]} </span>}
            {isDiscount ? <div style={{position:'relative'}}>
                <Tooltip target={divRef} content={discountTooltip} position='top' />
                <div ref={divRef} className={`${isDiscountLabelHovered ? 'discountLabel' : ''} ${styles.discountLabel}`} onMouseEnter={handleMouseEnterDiscountLabel}
                     onMouseLeave={handleMouseLeaveDiscountLabel}  >{discountPersent}</div>
            </div>: null}

            <Card className={`${styles.card} catalog-product-card-body`} onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}>
                {smallImageUrls.length ? 
                <Card.Img onClick={handleShow} variant="top" className={styles.cardImage} src={smallImageUrls[0]} />
                :
                <Card.Img onClick={handleShow} variant="top" className={styles.cardImage} src={noPhoto}  />
                }

                <Card.Body className={styles.cardBody}>
                    <Card.Title className={styles.cardTitleName} >{name}</Card.Title>

                    <div>
                        <div className={styles.pricesButtonsWrapper}>
                             <div className={styles.priceWrapper}>
                                 <div>
                                     <div className={styles.price}>{priceList[itemPriceIndex].UoMPrice.toLocaleString('uk-UA', {
                                         style: 'currency',
                                         currency: 'UAH',
                                         currencyDisplay: 'symbol'
                                     })}</div>
                                     <div className={styles.rrcWrapper}>
                                         <div style={{ paddingBottom: '5px' }}>
                                             <span  >РРЦ</span>: {recommendPrice.toLocaleString('uk-UA', {
                                                 style: 'currency',
                                                 currency: 'UAH',
                                                 currencyDisplay: 'symbol'
                                             }
                                         )}
                                         </div>
                                     </div>
                                 </div>
                             </div>
                             <div className={styles.cardAdditional}>

                                 {countInCart === 0 ?
                                     <div style={{height:'45px',display:'flex', alignItems:'center', justifyContent:'center'}}>
                                         {productButton}
                                     </div>
                                     :
                                     <div className={`${styles.btnShadow} p-inputgroup  productCountInput`} style={{height: '45px', position:"relative"}}>
                                         <span className={styles.productCountInputLabel}>У кошику:</span>
                                         <Button className={styles.changeCountButton} icon={`pi ${count <= 1 ? 'pi-trash' : 'pi-minus' }`} rounded text raised onClick={decrementCount}
                                                 style={{borderRadius: '10px 0px 0px 10px', height: '100%', width:'40%', color:'#666666', background:'#fbce07', boxShadow:"none"}}/>
                                         <Form.Control style={{textAlign: 'center', height: '100%', borderRadius:0, fontSize:'1.3rem'}} type="text" min={0} pattern="[0-9]*"
                                                       onClick={countHandleClick} onInput={countHandler}
                                                       value={count > 0 ? count + ' шт': 1 + ' шт'}/>
                                         <Button className={styles.changeCountButton} icon="pi pi-plus"  rounded text raised onClick={incrementCount}
                                                 style={{borderRadius: '0px 10px 10px 0px', height: '100%', width:'40%', color:'#666666', background:'#fbce07',  boxShadow:"none"}}/>
                                     </div>
                                 }

                             </div>
                         </div>
                    </div>
                </Card.Body>
            </Card>

            <div className={`${styles.modalBody}`}>

                <Dialog header={name} maximizable modal={true} visible={show} className="productCardModal"
                        style={{backgroundColor: '#e0e0e0', width: '90%', height: '90vh', color: '#495057'}}
                        onHide={() => setShow(false)}>
                    <ProductCardNew
                        id={id}
                        articleList={articleList}
                        number={number}
                        addToCart={add}
                        setShow={setShow}
                        price={totalAmount}
                        balance={balance}
                        deliveryDate={deliveryDate}
                    />
                </Dialog>
            </div>
        </div>
    )
}